import styled from "styled-components";

// Paleta de Cores do Tema Escuro
const colors = {
    background: '#1a1d24',
    backgroundLighter: '#2c313a',
    border: '#2c313a',
    textPrimary: '#f8f9fa',
    textSecondary: '#adb5bd',
    accent: '#ffd700', // Dourado
    danger: '#e57373', // Vermelho para o dark mode
};

export const Container = styled.aside`
    position: fixed;
    top: 0;
    left: 0;
    width: 300px;
    height: 100vh; // Garante que o container ocupe a altura toda
    background-color: ${colors.background};
    border-right: 1px solid ${colors.border};
    z-index: 999;
    
    display: flex;
    flex-direction: column;
    // REMOVIDO: justify-content: space-between; O flex-grow vai cuidar disso agora
    
    transform: translateX(-100%);
    transition: transform 0.4s ease-in-out;

    &.open {
        transform: translateX(0);
    }

    @media (max-width: 1000px) {
        width: 100%;
        border-right: none;
    }
`;

// --- SEÇÃO INFERIOR ---
// Renomeado de BottomSection para ser mais específico
export const BottomSection = styled.div`
    padding: 15px;
    // O flex-shrink: 0 impede que esta seção seja espremida
    flex-shrink: 0; 
`;

// --- LOGO ---
export const LogoBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px 20px;
    flex-shrink: 0; // Impede que o logo seja espremido

    img {
        width: 90px;
        margin-bottom: 12px;
    }

    span {
        font-weight: 700;
        font-size: 22px;
        color: ${colors.accent};
        letter-spacing: 1px;
    }
`;

// --- NAVEGAÇÃO ---
export const Mapper = styled.nav`
    // ADICIONADO: flex-grow faz esta área crescer e ocupar o espaço disponível
    flex-grow: 1; 
    // ADICIONADO: overflow-y permite a rolagem vertical apenas nesta área
    overflow-y: auto; 
    overflow-x: hidden; 

    display: flex;
    flex-direction: column;
    padding: 10px 15px;
    gap: 8px;

    a {
        text-decoration: none;
    }
`;

export const NavItem = styled.div`
    border-radius: 8px;
    transition: background-color 0.2s ease;
    cursor: pointer;
    position: relative;

    &:hover {
        background-color: ${colors.backgroundLighter};
    }
    
    &.active {
        background-color: ${colors.backgroundLighter};
        
        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            height: 60%;
            width: 4px;
            background-color: ${colors.accent};
            border-radius: 0 4px 4px 0;
        }
    }
`;

export const NavLink = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 14px 20px;
    font-size: 16px;
    font-weight: 500;
    color: ${colors.textPrimary};
    width: 100%;
    
    ${NavItem}.active & {
        font-weight: 600;
        color: #ffffff;
    }

    ${NavItem}.logout-link & {
        color: ${colors.danger};
        font-weight: 600;
    }
    ${NavItem}.logout-link:hover & {
        color: #ffcdd2;
    }
`;

export const IconWrapper = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
`;

// --- RODAPÉ / PERFIL ---
export const Footer = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 15px;
    margin-top: 8px;
    border-top: 1px solid ${colors.border};
    cursor: pointer;
    border-radius: 8px;
    transition: background-color 0.2s ease-in-out;

    &:hover {
        background-color: ${colors.backgroundLighter};
    }
`;

export const UserAvatar = styled.div`
    width: 45px;
    height: 45px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    border: 2px solid ${colors.border};

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const UserInfo = styled.div`
    .username {
        font-size: 16px;
        font-weight: 600;
        color: ${colors.textPrimary};
        margin: 0;
    }

    .view-profile {
        font-size: 14px;
        color: ${colors.textSecondary};
        margin: 0;
    }
`;